import { render, staticRenderFns } from "./EditPayment.vue?vue&type=template&id=2abb5646&scoped=true&"
import script from "./EditPayment.vue?vue&type=script&lang=js&"
export * from "./EditPayment.vue?vue&type=script&lang=js&"
import style0 from "./EditPayment.vue?vue&type=style&index=0&id=2abb5646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb5646",
  null
  
)

export default component.exports